import { IPublicationPackagesState } from './types';

export const defaultState: IPublicationPackagesState = {
  packagesList: [],
  changedByUser: false,
};
